<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  label = 'Password',
  placeholder = '',
  rounded = 'lg',
  hideDetails = 'auto',
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  hideDetails?: boolean | 'auto';
  rounded?: string | number | boolean;
}>();

const password = defineModel();

const showPassword = ref(false);
function togglePasswordVisibility() {
  showPassword.value = !showPassword.value;
}
</script>

<template>
  <v-text-field
    v-model="password"
    flat
    variant="solo-filled"
    autocomplete="current-password"
    :error-messages="errorMessages"
    :rounded="rounded"
    :hide-details="hideDetails"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :type="showPassword ? 'text' : 'password'"
    data-testid="password"
  >
    <template #append-inner>
      <slot name="append-inner">
        <v-icon data-testid="password-toggle" @click="togglePasswordVisibility">
          {{ showPassword ? 'mdi-eye' : 'mdi-eye-off' }}
        </v-icon>
      </slot>
    </template>
  </v-text-field>
</template>

<style></style>
